/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetPerformanceByPageCountQueryResponse, IngestionStatusControllerGetPerformanceByPageCountQueryParams, IngestionStatusControllerGetPerformanceByPageCount403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetPerformanceByPageCount";

function getIngestionStatusControllerGetPerformanceByPageCountUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/ingestion-status/performance-by-page-count` as const }  
  return res
}

/**
 * @description Returns processing time statistics grouped by document page count buckets (1-10, 11-50, 51-100, 100+). Includes P50, P90, P99 percentiles for both overall and per-step timing. Requires System Administrator role.
 * @summary Get performance metrics by document page count
 * {@link /api/v1/documents/ingestion-status/performance-by-page-count}
 */
export async function ingestionStatusControllerGetPerformanceByPageCount(params?: IngestionStatusControllerGetPerformanceByPageCountQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IngestionStatusControllerGetPerformanceByPageCountQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetPerformanceByPageCount403>, unknown>({ method : "GET", url : getIngestionStatusControllerGetPerformanceByPageCountUrl().url.toString(), params, ... requestConfig })  
  return res.data
}